import React, { useContext } from "react";
import { Container } from "react-bootstrap";
import classes from "./OurTeam.module.css";
import { MyContext } from "../../Context/MyContext";

const testimonials = [
  {
    title: "Alden Azzopardi",
    review:
      "The team delivered a robust, scalable product and stayed close until it was in our customers’ hands.",
  },
  {
    title: "Tayyab Nasir",
    review:
      "Their social strategy lifted our presence and turned quiet channels into a source of real inquiries.",
  },
  {
    title: "Armagham Zia",
    review:
      "The site they built is fast, clear, and finally looks like the company we are trying to be.",
  },
  {
    title: "Ali Siddiqui",
    review:
      "Virtual assistance that actually stuck. Reliable, efficient, and now part of how we operate.",
  },
];

export default function OurTeam() {
  const { appointmentRef } = useContext(MyContext);

  return (
    <section className={`sectionShell ${classes.section}`}>
      <Container>
        <div className={classes.intro}>
          <div className="sectionEyebrow">What clients say</div>
          <h2 className="sectionTitle">Work people come back for</h2>
          <p className="sectionLead">
            A short read from teams we’ve helped ship software, marketing, and
            operations.
          </p>
        </div>
        <div className={classes.quotes}>
          {testimonials.map((item) => (
            <blockquote key={item.title} className={classes.quote}>
              <p>“{item.review}”</p>
              <footer>{item.title}</footer>
            </blockquote>
          ))}
        </div>
        <button
          className="buttonHome"
          onClick={() => {
            window.location.hash = "#book-appointment";
            appointmentRef.current.scrollIntoView({
              behavior: "smooth",
              block: "start",
            });
          }}
        >
          Book a Call
        </button>
      </Container>
    </section>
  );
}
